import { DebtMapRequest, GeoJsonFeatureResponse } from '../../api-models';
import { DebtDimensionRequest } from '../../types/debt.type';
import { All, HTTPMethod } from '../../types/enums';
import {
  AdapterInterface, FrontendGeoJsonFeature,
} from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class PostWardMap extends BaseAdapter<GeoJsonFeatureResponse[]> implements AdapterInterface {
  rawResponse: GeoJsonFeatureResponse[];

  modifiedRequest: DebtMapRequest;

  async adaptResponse(request: { data: DebtDimensionRequest, signal: AbortSignal }): Promise<FrontendGeoJsonFeature[]> {
    const formattedRequest = this.adaptRequest(request.data);

    await this.fetchApiResponse('/api/debt/map-ward-data', HTTPMethod.Post, formattedRequest, request.signal);
    return this.displayResponse();
  }

  displayResponse(): FrontendGeoJsonFeature[] {
    const geoJsonFeatures: FrontendGeoJsonFeature[] = this.rawResponse.map((ward: GeoJsonFeatureResponse) => ({
      type: ward.type,
      id: ward.id,
      geometry: ward.geometry,
      properties: {
        name: ward.properties.ward_name,
        longitude: ward.properties.longitude,
        latitude: ward.properties.latitude,
        householdCount: ward.properties.household_count,
      },
    }));
    return geoJsonFeatures;
  }

  adaptRequest(request: DebtDimensionRequest): DebtMapRequest {
    const liftDataId = request.liftDataId === All.value ? null : Number(request.liftDataId);
    this.modifiedRequest = {
      snapshot: request.snapshot,
      lift_data_id: liftDataId,
      ward_name: request.wardName,
      metric_name: request.metricName,
      debt_type: request.debtType,
    };

    return this.modifiedRequest;
  }
}
